import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { BULK_CONFIRM_BOOKING_BY_VENDOR, BULK_CONFIRM_BOOKING_BY_VENDOR_ERROR, BULK_CONFIRM_BOOKING_BY_VENDOR_SUCCESS } from '../../../actions.js';

function* bulkBookingConfirmationByVendor({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/vendor/bulk-confirm-booking`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      if (response?.data?.code == 4089) cogoToast.warn(response?.data?.message);
      else cogoToast.success(response?.data?.message);
      yield put({
        type: BULK_CONFIRM_BOOKING_BY_VENDOR_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: BULK_CONFIRM_BOOKING_BY_VENDOR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: BULK_CONFIRM_BOOKING_BY_VENDOR_ERROR, payload: error });
  }
}

export function* watchBulkBookingConfirmationByVendor() {
  yield takeEvery(BULK_CONFIRM_BOOKING_BY_VENDOR, bulkBookingConfirmationByVendor);
}

function* bulkBookingConfirmationByVendorSaga() {
  yield all([fork(watchBulkBookingConfirmationByVendor)]);
}

export default bulkBookingConfirmationByVendorSaga;
